import React from 'react'
import { FormattedMessage } from 'react-intl'
import PageTitle from '../PageTitle'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined'
import { ListingConsumer, ListingProvider } from '../../context/ListingContext'
import { LanguageConsumer } from '../../context/LanguageContext'
import AddNewForm from '../../FormFields/EntityAddForm'
import AddNewDialog from '../Dialog/AddNewDialog'
import InvoicePackagesList from './PackagesList'
import PackageDetails from './PackageDetails'
import { arrangePackageData } from '../../utils/helpers'
import { Box, Button, LinearProgress, Typography } from '@material-ui/core'
import { FormLoader } from '../Loader/FormLoader'
import { useStyles } from './Styles'

const InvoicePackagePageContent = () => {
  const classes = useStyles()
  return (
    <ListingProvider entityName={'invoicePackages'}>
      <ListingConsumer>
        {({
          listingData, currentDialogAction, currentSelectedRow, dialogActionSubmit, cancelDialog, isDialogOpen, openDialog, entityName,
          downloadEntity, downloadLoadingProgress, downloadLoading
        }) => (
          <>
            <PageTitle title={<FormattedMessage id='InvoicePackagePageContent.PageTitle' />}
              addNewButton={true}
              addButtonFunction={() => openDialog()}
              addButtonText={<FormattedMessage id='InvoicePackage.addNew' />}
              addButtonIcon={<AddOutlinedIcon />} />

            <LanguageConsumer>
              {({ locale }) => (
                <>
                  <AddNewDialog
                    children={currentDialogAction === 'show' ?
                      <PackageDetails
                        currentData={arrangePackageData(currentSelectedRow)}
                        locale={locale} />
                      :
                      <AddNewForm
                        entityName={entityName}
                        currentData={currentSelectedRow}
                        onSubmit={dialogActionSubmit}
                        currentAction={currentDialogAction}
                        updateParentEntity={cancelDialog}
                        cancelDialog={() => cancelDialog()} />}
                    dialogAction={currentDialogAction}
                    DialogTitle={<FormattedMessage id={`invoicePackages.dialogTitle.${currentDialogAction}`}
                      values={{
                        id: currentSelectedRow?.packageId
                      }} />}
                    isDialogOpen={isDialogOpen}
                    cancelDialog={() => cancelDialog()}
                    additionalBtn={<>
                      {!!downloadLoading && <>
                        <FormLoader loading={true} />
                        <div className={classes.downloadProgressWrapper}>
                          <Box display="flex" alignItems="center" className={classes.progress}>
                            <Box width="100%" mr={1}>
                              <LinearProgress color={'primary'} variant="determinate" value={downloadLoadingProgress} />
                            </Box>
                            <Box minWidth={35}>
                              <Typography variant="body2"
                                color="primary">{`${downloadLoadingProgress}%`}</Typography>
                            </Box>
                          </Box>
                        </div>
                      </>}
                      <Button variant='contained' color='secondary'
                        disabled={currentSelectedRow?.status?.toString() !== '2'}
                        onClick={() => downloadEntity(currentSelectedRow?.packageId)}>
                        <CloudDownloadOutlinedIcon /> <FormattedMessage id='AddNewDialog.Download' />
                      </Button>
                    </>}
                  />

                  <InvoicePackagesList listingData={listingData} locale={locale} openDialog={openDialog} />
                </>
              )}
            </LanguageConsumer>
          </>
        )}
      </ListingConsumer>
    </ListingProvider>
  )
}

export default InvoicePackagePageContent
